import React from "react";
import { CircularProgress, Typography } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import api from "../common/api";
import axios from "axios";
import { Container, Row, Col } from "shards-react";
import CustomToolbar from "../common/AddButton";
import GridActions from "../common/GridActions";
import Button from "@material-ui/core/Button";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import PublishIcon from "@material-ui/icons/Publish";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Backdrop from "@material-ui/core/Backdrop";

class Subcontacts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      backdrop: false,
      menu: {
        open: false,
        anchorEl: "",
        contact_name: ""
      },
      subcontact_types: [{}],
      orderColumn: "",
      contact_type: "",
      orderOrder: "",
      q_rows: 10,
      filters: [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]
    };

    this.handleMenuClick = this.handleMenuClick.bind(this);
    this.handleMenuClose = this.handleMenuClose.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleRestore = this.handleRestore.bind(this);
  }

  async componentDidMount() {
    var contact_id = this.props.match.params.contact_id;
    await this.getContactName(contact_id);
    await this.changePage(
      contact_id,
      1,
      this.state.filters,
      "id",
      "asc",
      this.state.q_rows
    );
    this.setState({ contact_id: contact_id });
    await this.getSubContactTypes();
  }

  getSubContactTypes = () => {
    const token = localStorage.getItem("userToken");
    axios
      .get(api.subcontact_types, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var subcontact_types = [];
        var subcontact_type = this.state.contact_type
          ? this.state.contact_type
          : "Client";
        res.data.map((val, idx) => {
          if (val.subcontact_contact_type === subcontact_type) {
            subcontact_types.push(val);
          }
        });
        this.setState({ subcontact_types: subcontact_types });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getContactName(id) {
    var name = "";
    var contact_type = "";
    if (id !== 0) {
      if (id === "-1") {
        this.setState({
          contact_name: "Todos los proveedores",
          contact_type: "Provider"
        });
      } else {
        const token = localStorage.getItem("userToken");
        axios
          .get(api.contacts().get(id), {
            headers: { Authorization: `Bearer ${token}` }
          })
          .then(res => {
            name = res.data.client
              ? res.data.client.business_name
              : res.data.provider.business_name;
            contact_type = res.data.client ? "Client" : "Provider";
            this.setState({ contact_name: name, contact_type: contact_type });
          })
          .catch(err => {
            console.log(err);
          });
      }
    } else {
      this.setState({
        contact_name: "Todos los clientes",
        contact_type: "Client"
      });
    }
  }

  sort = (column, order) => {
    let temp = {};
    temp.column = column;
    temp.order = order;

    this.setState({ orderColumn: column, orderOrder: order });
    this.changePage(
      this.state.contact_id,
      this.state.page,
      this.state.filters,
      column,
      order,
      this.state.q_rows
    );
  };

  changePage = (contact_id, page, filterList, column, order, q_rows) => {
    this.setState({
      isLoading: true,
      filters: filterList
    });

    var orderColumn = column !== "" ? column : "";
    var orderOrder = order !== "" ? order : "";

    var q = "";
    var subcontact_type_id = "";
    var deleted_at = 0;

    if (filterList[3].length !== 0) {
      q = filterList[3][0];
    }
    if (filterList[4].length !== 0) {
      q = filterList[4][0];
    }

    if (filterList[5].length !== 0) {
      var subcontact_types = this.state.subcontact_types;
      subcontact_types.map((val, idx) => {
        if (val.name === filterList[5][0]) {
          subcontact_type_id = val.id;
        }
      });
    }
    if (filterList[11].length !== 0) {
      if (filterList[11][0] === "Si") deleted_at = 1;
    }

    const token = localStorage.getItem("userToken");
    axios
      .get(
        api
          .subcontacts()
          .index(
            contact_id,
            q,
            subcontact_type_id,
            page,
            orderColumn,
            orderOrder,
            q_rows,
            deleted_at
          ),
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(res => {
        this.setState({
          isLoading: false,
          page: res.data.page,
          data: res.data.data,
          count: res.data.total,
          rowsPerPage: res.data.per_page
        });
      })
      .catch(err => {
        console.log(err);
      });
  };
  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: "0px 0px 0px 0px",
            fontSize: "0.75rem"
          }
        },
        MUIDataTable: {
          responsiveStacked: {
            overflow: "unset",
            overflowX: "unset"
          }
        }
      }
    });

  handleDelete(id) {
    this.setState({ delete_id: id });
    var subcontact = "";
    id = this.state.contact_id;
    this.state.data.map((val, idx) => {
      if (val.contact.id === id) {
        subcontact = val.firstname + " " + val.lastname;
        this.setState({ delete_id: val.id });
      }
    });

    var message = "";
    if (subcontact !== "") {
      message =
        "Está a punto de dar de baja al subcontacto " +
        subcontact +
        ". ¿Está seguro?";
    } else {
      this.setState({ errors: true });
      message = "Hubo un problema al dar de baja el subcontacto.";
    }
    this.setState({ message: message, dialogOpen: true });
  }
  handleRestore(id) {
    const token = localStorage.getItem("userToken");
    var formData = new FormData();
    axios
      .post(api.subcontacts().restore(id), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(res => {
        this.setState({
          message: "Subcontacto rehabilitado con éxito!",
          dialogOpen: true
        });
        this.setState({ errors: false });
        this.setState({ delete_id: "" });
        this.setState({ rowId: "" });
      })
      .catch(err => {
        this.setState({ errors: true, dialogOpen: true });
        this.setState({ delete_id: "" });
        this.setState({
          message:
            "Ha ocurrido un error al rehabilitar el subcontacto, contacte a su administrador."
        });
      });
  }

  handleRedirect(e) {
    e.preventDefault();
    window.location.href = "/subcontacts/" + this.props.match.params.contact_id;
  }

  handleDialogClose(e) {
    e.preventDefault();
    this.setState({
      dialogOpen: false,
      errors: false,
      message: "",
      delete_id: ""
    });
  }

  confirmDelete() {
    const token = localStorage.getItem("userToken");

    return axios
      .delete(
        api.subcontacts().delete(this.state.delete_id),
        { headers: { Authorization: `Bearer ${token}` } },
        { params: { "subcontact[id]": this.state.delete_id } }
      )
      .then(res => {
        this.setState({ message: "Subcontacto dado de baja con éxito!" });
        this.setState({ errors: false });
        this.setState({ delete_id: "", rowId: "" });
      })
      .catch(err => {
        this.setState({ errors: true });
        this.setState({ delete_id: "" });
        this.setState({ message: err.response.data.errors["subcontact.id"] });
      });
  }

  handleDownload = () => {
    var subcontact_type_id = "";
    var q = "";
    var filterList = this.state.filters;
    if (filterList[2].length !== 0) {
      q = filterList[2][0];
    }
    if (filterList[3].length !== 0) {
      q = filterList[3][0];
    }

    if (filterList[5].length !== 0) {
      var subcontact_types = this.state.subcontact_types;
      subcontact_types.map((val, idx) => {
        if (val.name === filterList[5][0]) {
          subcontact_type_id = val.id;
        }
      });
    }
    var formData = new FormData();
    formData.set("contact_id", this.state.contact_id);
    formData.set("q", q);
    formData.set("subcontact_type_id", subcontact_type_id);

    const token = localStorage.getItem("userToken");
    axios
      .post(api.subcontacts().export(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        this.handleCloseBackdrop();
        window.location.href = response.data;
      })
      .catch(error => {
        alert("Falló la descarga");
      });
  };

  handleMenuClick(event, id) {
    var menu = {};
    menu.open = true;
    menu.anchorEl = event.currentTarget;
    this.state.data.map((val, idx) => {
      if (val.id === id) {
        this.setState({ contact_id: val.contact.id });
      }
    });
    this.setState({ menu: menu, rowId: id });
  }

  handleMenuClose() {
    var menu = {};
    menu.open = false;
    menu.anchorEl = null;
    this.setState({ menu: menu });
  }

  handleFilterSubmit = (page, filterList) => () => {
    page = 0;
    this.setState({ page });
    this.changePage(
      this.state.contact_id,
      page,
      filterList,
      this.state.orderColumn,
      this.state.orderOrder,
      this.state.q_rows
    );
  };

  handleCloseBackdrop = () => {
    var backdrop = !this.state.backdrop;
    this.setState({ backdrop: backdrop });
  };

  render() {
    var subcontact_types_names = [];
    this.state.subcontact_types.map((val, idx) => {
      subcontact_types_names.push(val.name);
    });

    const columns = [
      {
        name: "id",
        label: "ID",
        options: {
          filter: false,
          sort: true,
          sortDirection:
            this.state.orderColumn === "id" ? this.state.orderOrder : null
        }
      },
      {
        name: "contact.id",
        label: "ID. Contacto",
        options: {
          display: false,
          filter: false
        }
      },
      {
        name: "contact.hansa_code",
        label: "Cod. Hansa",
        options: {
          filter: false,
          sort: false,
          display: false
        }
      },
      {
        name: "firstname",
        label: "Nombre",
        options: {
          filter: true,
          filterType: "textField",
          sort: true,
          sortDirection:
            this.state.orderColumn === "firstname"
              ? this.state.orderOrder
              : null
        }
      },
      {
        name: "lastname",
        label: "Apellido",
        options: {
          filter: true,
          filterType: "textField",
          sort: true,
          sortDirection:
            this.state.orderColumn === "lastname" ? this.state.orderOrder : null
        }
      },
      {
        name: "subcontact_type.name",
        label: "Tipo de Subcontacto",
        options: {
          filter: true,
          filterType: "dropdown",
          filterOptions: { names: subcontact_types_names }
        }
      },
      {
        name:
          this.state.contact_id === "0"
            ? "parent_contact.client.business_name"
            : "parent_contact.provider.business_name",
        label: "Contacto",
        options: {
          filter: false,
          display: this.state.contact_id > 0 ? false : true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const contact_id = tableMeta.rowData[10];
            return <a href={"/subcontacts/" + contact_id}>{value}</a>;
          }
        }
      },
      {
        name: "contact.email",
        label: "Email",
        options: {
          filter: false,
          sort: false
        }
      },
      {
        name: "contact.phone",
        label: "Tel. Fijo",
        options: {
          filter: false,
          sort: false
        }
      },
      {
        name: "contact.mobile",
        label: "Tel. Móvil",
        options: {
          filter: false,
          sort: false
        }
      },
      {
        name: "parent_contact.id",
        label: "# Contacto Padre",
        options: {
          display: false,
          filter: false,
          sort: false
        }
      },
      {
        name: "deleted_at",
        label: "Dado de baja",
        options: {
          filter: true,
          filterType: "select",
          filterOptions: {
            names: ["Si", "No"]
          },
          sort: false,
          display: false,
          filterList: this.state.filters[11]
        }
      },
      {
        name: "actions",
        label: "Acciones",
        options: {
          filter: false,
          sort: false,
          setCellHeaderProps: value => {
            return {
              style: {
                textAlign: "center"
              }
            };
          },
          customBodyRender: (value, tableMeta, updateValue) => {
            var id = tableMeta.rowData[0];
            var contact_id = tableMeta.rowData[0];
            var deleted_at = tableMeta.rowData[11];
            if (
              deleted_at !== "" &&
              deleted_at !== undefined &&
              deleted_at !== null
            )
              return (
                <Button
                  variant="contained"
                  onClick={() => {
                    this.handleRestore(id);
                  }}
                >
                  Rehabilitar
                </Button>
              );

            return (
              <GridActions
                id={id}
                contact_id={contact_id}
                module="clients"
                actions={{
                  edit: { url: "subcontact/" + id, action: "edit" },
                  view: { url: "subcontact/" + id + "/1", action: "view" },
                  audit: {
                    url:
                      "subcontacts/" +
                      this.state.contact_id +
                      "/" +
                      this.state.rowId +
                      "/audit"
                  },
                  subcontacts: { url: null },
                  mobile:
                    this.state.contact_type === "Client"
                      ? { url: "/mobile/user/" + this.state.rowId }
                      : {},
                  dashboard:
                    this.state.contact_type === "Client"
                      ? { url: "/dashboard/user/" + this.state.rowId }
                      : {},
                  providerUser:
                    this.state.contact_type === "Provider"
                      ? { url: "/providers/user/" + this.state.rowId }
                      : {}
                }}
                onDelete={this.handleDelete}
                onMenuClick={this.handleMenuClick}
                onMenuClose={this.handleMenuClose}
                open={this.state.menu.open}
                anchorEl={this.state.menu.anchorEl}
                hasMenu={true}
              />
            );
          }
        }
      }
    ];

    const { data, count, q_rows, isLoading } = this.state;

    const options = {
      filter: true,
      search: false,
      selectableRows: true,
      filterType: "dropdown",
      customToolbar: () => {
        return this.state.contact_id !== "0" &&
          this.state.contact_id !== "-1" ? (
          <React.Fragment>
            <CustomToolbar url={"new"} />
            <Tooltip title={"Importar"}>
              <IconButton
                onClick={e => {
                  window.location.href = this.state.contact_id + "/import";
                }}
              >
                <PublishIcon />
              </IconButton>
            </Tooltip>
          </React.Fragment>
        ) : (
          ""
        );
      },
      responsive: "stacked",
      serverSide: true,
      onFilterDialogOpen: () => {
        console.log("filter dialog opened");
      },
      onFilterDialogClose: () => {
        console.log("filter dialog closed");
      },
      onFilterChange: (column, filterList, type) => {
        if (type === "chip") {
          this.handleFilterSubmit(this.state.page, filterList)();
        }
      },
      customFilterDialogFooter: filterList => {
        return (
          <div style={{ marginTop: "40px" }}>
            <Button
              variant="contained"
              onClick={this.handleFilterSubmit(this.state.page, filterList)}
            >
              Aplicar
            </Button>
          </div>
        );
      },
      count: count,
      rowsPerPage: q_rows,
      onColumnSortChange: (changedColumn, direction) => {
        let order = "desc";
        if (direction === "ascending") {
          order = "asc";
        }
        this.setState({ isLoading: true, data: [] });
        this.sort(changedColumn, order);
      },
      onChangeRowsPerPage: numberOfRows => {
        this.setState({ isLoading: true, data: [], q_rows: numberOfRows });
        this.changePage(
          this.state.contact_id,
          this.state.page,
          this.state.filters,
          this.state.orderColumn,
          this.state.orderOrder,
          numberOfRows
        );
      },
      onDownload: () => {
        this.setState({ backdrop: true });
        this.handleDownload();
        return false;
      },
      onTableChange: (action, tableState) => {
        // a developer could react to change on an action basis or
        // examine the state as a whole and do whatever they want

        switch (action) {
          case "changePage":
            this.setState({ data: [] });
            this.changePage(
              this.state.contact_id,
              tableState.page + 1,
              this.state.filters,
              this.state.orderColumn,
              this.state.orderOrder,
              this.state.q_rows
            );
            break;
          default:
            break;
        }
      },
      textLabels: {
        body: {
          noMatch: this.state.isLoading ? (
            <CircularProgress />
          ) : (
            "No hay resultados"
          ),
          toolTip: "Ordenar",
          columnHeaderTooltip: column => `Ordenar para ${column.label}`
        },
        filter: {
          all: "Todos los resultados",
          title: "Tus filtros",
          reset: "Resetear"
        },
        toolbar: {
          search: "Buscar",
          downloadCsv: "Exportar XLS",
          print: "Imprimir",
          viewColumns: "Ver columnas",
          filterTable: "Filtros"
        },
        pagination: {
          next: "Siguiente",
          previous: "Anteior",
          rowsPerPage: "Cantidad por página:",
          displayRows: "de"
        },
        viewColumns: {
          title: "Ver columnas"
        },
        selectedRows: {
          text: "fila(s) seleccionadas"
        }
      }
    };

    return (
      <Container fluid className="main-content-container px-4">
        <Row>
          <Col className="p-2">
            <div>
              <Dialog
                open={this.state.dialogOpen}
                onClose={e => this.handleDialogClose(e)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">Dar de baja!</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    {this.state.message}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  {!this.state.errors ? (
                    this.state.delete_id === "" ? (
                      <div>
                        <Button
                          onClick={e => {
                            this.handleRedirect(e);
                          }}
                          color="primary"
                        >
                          Continuar
                        </Button>
                      </div>
                    ) : (
                      <div>
                        <Button
                          onClick={e => this.handleDialogClose(e)}
                          color="primary"
                          autoFocus
                        >
                          Cancelar
                        </Button>
                        <Button
                          onClick={this.confirmDelete.bind(this)}
                          color="primary"
                        >
                          Continuar
                        </Button>
                      </div>
                    )
                  ) : (
                    <div>
                      <Button
                        onClick={e => this.handleDialogClose(e)}
                        color="primary"
                      >
                        Continuar
                      </Button>
                    </div>
                  )}
                </DialogActions>
              </Dialog>
            </div>
            <MuiThemeProvider theme={this.getMuiTheme()}>
              <Backdrop
                open={this.state.backdrop}
                onClick={this.handleCloseBackdrop}
                style={{ zIndex: 10000, color: "#3f51b5" }}
              >
                <CircularProgress color="inherit" />{" "}
                <Typography className="ml-2" variant="h5" color="primary">
                  Descargando...
                </Typography>
              </Backdrop>

              <MUIDataTable
                title={
                  <Typography variant="title">
                    Lista de Subcontactos de {this.state.contact_name}
                  </Typography>
                }
                data={data}
                columns={columns}
                options={options}
              />
            </MuiThemeProvider>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Subcontacts;
